import { AppStyled, GlobalStyle } from '../GlobalStyle';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { init } from 'Libs/apollo';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';
import InitiStore from 'Store/InitiStore';
import { BrowserRouter } from 'react-router-dom';
import ModalContainer from 'react-modal-promise';
import { FooterV2 } from 'Components/FooterV2';
import styled from 'styled-components';
import DesignStore from 'Store/DesignStore';
import { DynamicStylesExternal } from 'Components/DynamicStylesExternal';

// Composant interne qui utilise le store
const FooterContent = () => {
  // const isLoaded = DesignStore.useStoreState((state) => state.isLoaded);

  return (
    // <FooterContainer className={isLoaded ? 'loaded' : ''}>
    // <FooterContainer>
    <FooterV2 external />
    // </FooterContainer>
  );
};

const App = () => {
  const client = init();

  return (
    <AppStyled>
      <BrowserRouter>
        <AuthStore.Provider initialData={client}>
          <DesignStore.Provider initialData={client}>
            <UiStore.Provider>
              <ApolloProvider client={client}>
                <>
                  <InitiStore />
                  <GlobalStyle />
                  <DynamicStylesExternal />
                  <FooterContent />
                  <ModalContainer />
                </>
              </ApolloProvider>
            </UiStore.Provider>
          </DesignStore.Provider>
        </AuthStore.Provider>
      </BrowserRouter>
    </AppStyled>
  );
};

export default App;
